// extracted by mini-css-extract-plugin
export var productImage = "_wz-0";